import DisplayMetalDivide from './DisplayMetalDivide';
import EditMetalDivide from './EditMetalDivide';
import ReportMetalDivide from './ReportMetalDivide';

export { DisplayMetalDivide, EditMetalDivide, ReportMetalDivide };
export default { EditMetalDivide, DisplayMetalDivide, ReportMetalDivide };
